import { BaseComponent } from '../../base-component';
import { eventQBus } from '@otto-ec/global-resources/event-q-bus';

export class UpsellingComponent extends BaseComponent {
    public rootSelector = '.js_pdp_upselling';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        eventQBus.emit('ft5.upselling.load', {
            variationId: this.getRootElement().dataset.variationId,
            onexE3823Variant: this.getRootElement().dataset.onexE3823Variant,
        });
    }
}
